import React from 'react'
import styled from '@emotion/styled'

const StyledButton = styled('button')`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 3px 20px;
  margin: 5px 0px;
  align-items: center;
  width: inherit;
  background: #F0C17D;
  color: #36174D;
  //box-shadow: inset 0px 0px 1px 1px #B8860Bdd;
  border-radius: 5px;
  overflow: hidden;
  //color: white;
`

const UnStyledButton = styled('button')`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 3px 20px;
  margin: 5px 0px;
  align-items: center;
  width: inherit;
  background: inherit;
  //box-shadow: inset 0px 0px 10px 4px #363755;
  border: 0px;
  border-radius: 5px;
  color: white;
  overflow: hidden;
  &:hover {
    background: #B8860B55;
  }
`

const Item = styled('div')`
  font-style: normal;
  font-weight: 400;
  font-size: 17px;
  line-height: 19px;
  margin-bottom: 2px;
`

const SelectorButton = (props) => {
  const {isSelected, onClick, data } = props

  if (!isSelected) {
    return (
      <UnStyledButton onClick={onClick}>
        <Item style={{marginLeft: "-10px"}}>{data.name}</Item>
        <Item style={{marginRight: "-10px", marginLeft: "10px"}}>{data.premium ? "Supreme":"Regular"}</Item>
      </UnStyledButton>
    )
  }

  return (
    <StyledButton onClick={onClick}>
      <Item style={{marginLeft: "-10px"}}>{data.name}</Item>
      <Item style={{marginRight: "-10px", marginLeft: "10px"}}>{data.premium ? "Supreme":"Regular"}</Item>
    </StyledButton>
  )
}

export default SelectorButton
